import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getHistoricalFilings } from "../../../features/state/StateFiling-slice";
import { GenerateFilingColumnDefinition } from "../../../components/stateful/table/TableHelper";
import { ConstructFilingTableTemplate } from "../../../utilities/interfaces/Filing";
import { filingAPI, filingFormAPI, filingFormTypeAPI } from "../../../utilities/api";

export const useHistoricalFilingsController = (props: any) => {
  const {} = props;

  const values = useAppSelector((state) => state.filings.historicalFilings);
  const loading = useAppSelector((state) => state.filings.fetchingHistoricalFilings);
  const dispatch = useAppDispatch();

  const [columns, setColumns] = useState<any>([]);

  useEffect(() => {
    if (values.length < 1) {
      dispatch(getHistoricalFilings());
    }

    if (columns.length < 1) {
      generateColumnData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const generateColumnData = async () => {
    setColumns(await GenerateFilingColumnDefinition(ConstructFilingTableTemplate()));
  }

  const [selectedFiling, setSelectedFiling] = useState<any>();
  const [filingFormType, setFilingFormType] = useState<any>();
  const [filingForm, setFilingForm] = useState<any>();

  const handleRowSelect = async (filing: any) => {
    setSelectedFiling(filing);
    await filingFormAPI.getFilingFormById(filing.filingFormId).then((form: any) => {
      setFilingForm(form);
      filingFormTypeAPI.getFilingFormTypeById(form.filingFormTypeId).then((type: any) => {
        setFilingFormType(type);
      });
    });
    toggleFilingDialog();
  }

  const [filingDialogOpen, setFilingDialogOpen] = useState<boolean>(false);

  const toggleFilingDialog = () => {
    if (filingDialogOpen) {
      setSelectedFiling(undefined);
    }
    setFilingDialogOpen(!filingDialogOpen);
  }

  return {
    values,
    loading,
    columns,
    filingDialogOpen,
    selectedFiling,
    filingForm,
    filingFormType,
    handleRowSelect,
    toggleFilingDialog,
  };
}